export default __webpack_public_path__ + "static/media/gallery_00.f7a28891.jpg";